import type {ComputationResult} from './../computation-result';
import type {Computation} from './../computation';
import type {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.Sum
 */
export interface Sum extends Computation._UnivariateComputation {
    confidence?: number | null;

    // PolyJson type
    type: 'sum';
}

export namespace Sum {
    export const type = 'sum';
}

/** @deprecated Use Computation.isSum() */ export function isSum(toTest: Computation): toTest is Sum { return Sum.type === toTest['type']; }

export namespace Sum {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.Sum$SumResult
     */
    export interface SumResult extends _AvailableResult {
        lower?: number | null;
        upper?: number | null;
        value: number;

        // PolyJson type
        type: 'sum';
    }

    export namespace SumResult {
        export const type = 'sum';
    }

    /** @deprecated Use ComputationResult.isSumResult() */ export function isSumResult(toTest: ComputationResult): toTest is SumResult { return SumResult.type === toTest['type']; }
}